import { validateToken } from '@shared/api/services/auth.service';
import { isAccessTokenExpiring, refreshAccessToken } from '@shared/api/apiConfig';
import { store } from '@shared/store';
import { logout, setOrgId, setUserType, type UserType } from '@shared/store/exchangeSlice';

export const clearAuthSession = () => {
  store.dispatch(logout());
  sessionStorage.clear();
  document.cookie = 'refreshToken=; Max-Age=0; path=/; SameSite=Lax';
};

export const handleValidateToken = async (setLoggedIn?: (isLoggedIn: boolean) => void) => {
  try {
    let accessToken = store.getState().exchange.accessToken;
    if (!accessToken) {
      try {
        accessToken = await refreshAccessToken(false);
      } catch {
        setLoggedIn?.(false);
        return null;
      }
    }

    if (isAccessTokenExpiring(accessToken, 0)) {
      accessToken = await refreshAccessToken(false);
    }

    const validationResponse = (await validateToken()) as
      | { data?: { userType?: string, orgId?: string };  code?: number }
      | null
      | undefined;

    if (validationResponse?.code === 200) {
      const userType = (validationResponse.data?.userType ) as
        | UserType
        | null;
        const orgId = (validationResponse.data?.orgId ) as
        | string
        | null;
      store.dispatch(setUserType(userType));
      store.dispatch(setOrgId(orgId));
      setLoggedIn?.(true);
      return userType;
    }

    clearAuthSession();
    setLoggedIn?.(false);
    return null;
  } catch {
    clearAuthSession();
    setLoggedIn?.(false);
    return null;
  }
};
